import React from 'react';
import { connect } from 'react-redux';;
import { eventByType } from '../../../../api/eventsApi';
import tagular from '../../../../util/tagular';


import './contentResult.scss';

class ResultIndex extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAllResults: false,
            showAllResultsABTest: false
        };

        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
    }

    componentDidMount() {
        this.runShowAllResultsAbTest();
    }

    componentDidUpdate(prevProps) {
        if (this.props.filteredResults !== prevProps.filteredResults) {
            this.setState({ showAllResults: false });
        }
    }

    handleShowMoreClick(e) {
        this.setState({ showAllResults: true });

        const { assessment, inlineParentMetadata } = this.props;

        eventByType('show-all-results', assessment.id, { inlineParentMetadata });

        tagular.sendElementClickedEvent(e, {
            assessmentName: assessment.internalName,
            action: 'EXPAND'
        });
    }

    toggleButtonDisplay() {
        let display = 'show';

        if (this.state.showAllResults) {
            display = 'hide';
        }

        return display;
    }

    // applying AB test using preamp
    runShowAllResultsAbTest() {
        if (
            window._Preamp &&
            window._Preamp.actions &&
            window._Preamp.actions.placements.find(
                placement => placement.assetName === 'hide show all button'
            )
        ) {
            this.setState({ showAllResultsABTest: true });
        }
    }

    render() {
        const { filteredResults, selectedFilters, assessment } = this.props;

        const result = filteredResults && filteredResults[0] ? filteredResults[0] : null;

        return (
            <>
                {result && (<>
                    <div className="img-container">
                        <img className="result-img" src={result.imageUrl} alt="" />
                    </div>
                    <h1 className="results-title">{result.title}</h1>
                    <div className='results-intro' dangerouslySetInnerHTML={{ __html: result.briefDescription }} />
                </>)}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        filteredResults: state.session.filteredResults,
        selectedFilters: state.session.selectedFilters.inResults,
        inlineParentMetadata: state.inline.parentMetadata
    };
};

export default connect(mapStateToProps, null)(ResultIndex);
